import { render, staticRenderFns } from "./MediakitMediumDialog.vue?vue&type=template&id=4b304e81&"
import script from "./MediakitMediumDialog.vue?vue&type=script&lang=js&"
export * from "./MediakitMediumDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports